"use client";

import Image from "next/image";

import { cn } from "@/utils/lib";

import { InfoTooltip } from "./info-tooltip";

interface TransactionVolumeBadgeProps {
  type: keyof typeof TransactionVolumeBadgeType;
  text: React.ReactNode;
  width?: number;
  className?: string;
  imageClassName?: string;
}

export enum TransactionVolumeBadgeType {
  Whale = "Whale",
  Dolphin = "Dolphin",
  Fish = "Fish",
  Shrimp = "Shrimp",
}

const TransactionVolumeBadgeIconMap = {
  [TransactionVolumeBadgeType.Whale]: "/assets/user-badges/whale.gif",
  [TransactionVolumeBadgeType.Dolphin]: "/assets/user-badges/dolphin.gif",
  [TransactionVolumeBadgeType.Fish]: "/assets/user-badges/fish.webp",
  [TransactionVolumeBadgeType.Shrimp]: "/assets/user-badges/shrimp.png",
};

export const TransactionVolumeBadge: React.FC<TransactionVolumeBadgeProps> = ({
  type = TransactionVolumeBadgeType.Whale,
  width = 24,
  className = "",
  text,
  imageClassName = "",
}) => {
  return (
    <>
      <InfoTooltip className={className} text={<span>{text}</span>}>
        <div>
          <Image
            src={
              TransactionVolumeBadgeIconMap[type] ||
              TransactionVolumeBadgeIconMap.Whale
            }
            unoptimized
            width={width}
            height={0}
            alt={`${type} badge`}
            className={cn(imageClassName)}
          />
        </div>
      </InfoTooltip>
    </>
  );
};
